var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaverik(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 250 25",
    width: 400,
    height: 80,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.877 18.178h-4.572V0h-6.578v22.727h13.286l19.669-16.613V0zM26.351 0v.064l-9.863 6.638L6.583.021V0H0v22.723L6.583 25V5.412l9.905 6.658 9.863-6.615V25l6.583-2.256h.021V0zM236.725 0v9.185h-18.789V0h-6.572v22.745L217.936 25V13.777h9.795l13.252 8.968 9.017-.02-13.362-9.013h6.637V0zM181.818 0l.023 4.567h9.829v13.594h-9.829v4.566h26.114v-4.566h-9.805V4.567h9.805V0zM106.818 0v22.686l32.955.041v-4.544h-26.35v-4.438h21.788l4.562-4.503v-.064h-26.35V4.523h26.35V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.104 0v9.27l-4.468 4.442v.065h4.448v8.948L149.646 25V13.732h7.619l13.3 9.014 8.98-.021-13.168-8.993h9.499L175.854 0h-32.75Zm6.542 9.16h19.626V4.507h-19.626v4.655ZM36.364 0v22.724L42.968 25V13.767h19.746V25l6.604-2.256V0H36.364Zm6.604 9.19h19.748V4.53H42.968V9.19Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaverik);
export default __webpack_public_path__ + "static/media/maverik.74c26f1b041fb3252f84a8f6b9d127ee.svg";
export { ForwardRef as ReactComponent };